import React from "react";
import RussianPostLogo from "russian-post.svg";

export default function RussianPost(props) {
    return (
        <>
            <div className="card card-body font-size-14 py-2 mb-3">
                <div className="d-flex justify-content-between mb-3">
                    <div>
                        Подключение личного кабинета для авторизации в системе <b>&quot;Почта России&quot;</b>
                    </div>
                    <RussianPostLogo className="parcel__logo" />
                </div>
                <form onSubmit={props.handleSubmit}>
                    {props.renderField("russianPost", "login")}
                    {props.renderField("russianPost", "password")}
                    {props.renderCheckbox("russianPost", "hasContract")}
                    <div className="mb-3">
                        <button
                            disabled={props.disabled || props.checkingRussianPostConnection}
                            type="button"
                            className="btn btn-sm btn-secondary"
                            onClick={props.handleCheckRussianPostConnection}
                        >
                            {props.checkingRussianPostConnection ? "Проверка..." : "Проверить подключение"}
                        </button>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                        <button disabled={props.disabled} type="submit" className="btn btn-sm btn-brand">
                            Сохранить
                        </button>
                        {props.canDelete && (
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={props.handleDelete}
                            >
                                Удалить интеграцию
                            </button>
                        )}
                    </div>
                </form>
            </div>
            <div className="card card-body font-size-14 py-2">
                Ознакомьтесь с инструкцией для подключения интеграции с системой отслеживания перейдя по ссылке:
                <a
                    href="https://cargorun.omnidesk.ru/knowledge_base/item/365162?sid=67618"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://cargorun.omnidesk.ru/knowledge_base/item/365162?sid=67618
                </a>
            </div>
        </>
    );
}
